import { Api } from '@deepcloud/api-base'
import { mergeConfig } from '@deepcloud/http-client'
import { withQueryParams } from '../../../shared'
import type {
  HttpClient,
  HttpClientRequestConfig,
} from '@deepcloud/http-client'
import type { SourceInfo } from '../../../shared'
import type {
  ChatDeleteAllSessionsParams,
  ChatGetSessionsParams,
  ChatGetSourcesParams,
  ChatHistoryResponse,
  FeedbackCreateRequest,
} from '../../@types'

export class ChatAPI extends Api {
  constructor(httpClient: HttpClient) {
    super(httpClient)
  }

  /**
   * Get Chat Sources
   * -------------------
   * Errors:
   * - 422 Validation Error → {@link HTTPValidationError}
   */
  async getSources(
    params?: ChatGetSourcesParams,
    config?: HttpClientRequestConfig,
  ) {
    const path = `/chat/sources`

    return this.httpClient.get<SourceInfo[]>(
      path,
      mergeConfig({ params }, config),
    )
  }

  /**
   * Get My Chats
   * -------------------
   * Errors:
   * - 422 Validation Error → {@link HTTPValidationError}
   */
  async getSessions(
    params: ChatGetSessionsParams,
    config?: HttpClientRequestConfig,
  ) {
    const path = `/chat/sessions`

    return this.httpClient.get<unknown>(path, mergeConfig({ params }, config))
  }

  /**
   * Delete All Sessions
   * -------------------
   * Errors:
   * - 422 Validation Error → {@link HTTPValidationError}
   */
  async deleteAllSessions(
    params?: ChatDeleteAllSessionsParams,
    config?: HttpClientRequestConfig,
  ) {
    const path = withQueryParams(`/chat/sessions`, params)

    return this.httpClient.delete<unknown>(path, config)
  }

  /**
   * Get Chat Details
   * -------------------
   * Errors:
   * - 422 Validation Error → {@link HTTPValidationError}
   */
  async getSession(sessionId: number, config?: HttpClientRequestConfig) {
    const path = `/chat/sessions/${sessionId}`

    return this.httpClient.get<ChatHistoryResponse>(path, config)
  }

  /**
   * Delete Session
   * -------------------
   * Errors:
   * - 422 Validation Error → {@link HTTPValidationError}
   */
  async deleteSession(sessionId: number, config?: HttpClientRequestConfig) {
    const path = `/chat/sessions/${sessionId}`

    return this.httpClient.delete<unknown>(path, config)
  }

  /**
   * Report Message
   * -------------------
   * Errors:
   * - 422 Validation Error → {@link HTTPValidationError}
   */
  async reportMessage(
    payload: FeedbackCreateRequest,
    config?: HttpClientRequestConfig,
  ) {
    const path = `/chat/feedback`

    return this.httpClient.post<unknown>(path, payload, config)
  }
}
